// src/components/admin/UserRoleSelect.tsx
import React from "react";
import { Select, MenuItem, Chip } from "@mui/material";

const ROLE_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
  super_admin: { label: "Super Admin", color: "#7C3AED", bg: "#F3E8FF" },
  admin: { label: "Admin", color: "#2563EB", bg: "#DBEAFE" },
  user: { label: "User", color: "#6B7280", bg: "#F3F4F6" },
};

interface UserRoleSelectProps {
  value: string;
  onChange: (role: string) => void;
  disabled?: boolean;
  readOnly?: boolean;
}

const UserRoleSelect: React.FC<UserRoleSelectProps> = ({ value, onChange, disabled, readOnly }) => {
  const config = ROLE_CONFIG[value] || ROLE_CONFIG.user;

  if (readOnly) {
    return (
      <Chip
        label={config.label}
        size="small"
        sx={{
          bgcolor: config.bg,
          color: config.color,
          fontWeight: 600,
          fontSize: "0.75rem",
          height: 24,
        }}
      />
    );
  }

  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      size="small"
      sx={{
        minWidth: 130,
        fontSize: "0.8rem",
        "& .MuiSelect-select": { py: 0.5 },
      }}
    >
      <MenuItem value="super_admin">Super Admin</MenuItem>
      <MenuItem value="admin">Admin</MenuItem>
      <MenuItem value="user">User</MenuItem>
    </Select>
  );
};

export { ROLE_CONFIG };
export default UserRoleSelect;
